import { type ActionItem } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { SurveysPath } from 'entities/ExportRouters'

export const editSurvey = (id: number): ActionItem => {
  return {
    text: 'Edit',
    icon: 'edit',
    onAction: () => {
      uiStore.changeRoute({
        path: SurveysPath.edit(id),
      })
    },
  }
}
